export default __webpack_public_path__ + "static/media/bg-masthead-3.0cd83e59.webp";